import React from "react";
import PropTypes from "prop-types";

import { UserIcon, AVATAR_SIZE } from "widgets/datadisplay";

import styles from "./style.css";

export function SingleUser(props) {
  const { value } = props;
  return (
    <div className={styles.singleuser}>
      {value && (
        <React.Fragment>
          <UserIcon
            userId={value._id}
            name={value.Name}
            size={AVATAR_SIZE.SIZE24}
          />
          <span className={"ellipsis"}>{value.Name}</span>
        </React.Fragment>
      )}
    </div>
  );
}

SingleUser.propTypes = {
  column: PropTypes.any,
  value: PropTypes.any
};
